import { render, staticRenderFns } from "./RetrievalStudents.vue?vue&type=template&id=471055e9&scoped=true&"
import script from "./RetrievalStudents.vue?vue&type=script&lang=js&"
export * from "./RetrievalStudents.vue?vue&type=script&lang=js&"
import style0 from "./RetrievalStudents.vue?vue&type=style&index=0&id=471055e9&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471055e9",
  null
  
)

export default component.exports